import React, { useState, useEffect, useRef, useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import './CardPicker.css';

const CardPicker = ({ type, card, onConfirm, onClose, limit = 15 }) => {
  const [cards, setCards] = useState([]);
  const [selectedCards, setSelectedCards] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const fetchingRef = useRef(false);

  const fetchCards = useCallback(async () => {
    if (fetchingRef.current) return;
    fetchingRef.current = true;

    try {
      const response = await axios.get(
        `/api/users/get-user-tokens.php?cardid=${card}&type=${type}&search=${searchQuery}&page=${page}`
      );
      const newCards = response.data;
      if (newCards.length === 0) {
        setHasMore(false);
      } else {
        setCards((prevCards) => [...prevCards, ...newCards]);
        setPage((prevPage) => prevPage + 1);
      }
    } catch (error) {
      console.error('Error fetching cards:', error);
      setHasMore(false);
    } finally {
      fetchingRef.current = false;
    }
  }, [card, type, searchQuery, page]);

  useEffect(() => {
    setCards([]);
    setPage(0);
    setHasMore(true);
    fetchCards();
  }, [searchQuery]);

  const handleCardClick = (cardData) => {
    if (type === 'edit') {
      const firstCardNId = cards.length > 0 ? cards[0].id : null;
      window.location.href = `/?action=edit&id=${cardData.cardid}&nid=${firstCardNId}&redirect=1`;
    } else {
      setSelectedCards((prevSelectedCards) =>
        prevSelectedCards.some(c => c.id === cardData.id)
          ? prevSelectedCards.filter(c => c.id !== cardData.id)
          : prevSelectedCards.length < limit
          ? [...prevSelectedCards, cardData]
          : prevSelectedCards
      );
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleConfirm = async () => {
    if (type === 'add' || type === 'delete') { 
      if (selectedCards.length > 0) {
        try {
          const action = type === 'add' ? 'add' : 'delete';
          const url = `/api/users/add-user-tokens.php`;
          const data = {
            action: action,
            mastercard: card,
            dataArray: selectedCards.map(c => c.cardid),
          };
          const response = await axios.post(url, data);
          console.log('Response:', response.data);
        } catch (error) {
          console.error('Error processing cards:', error);
        }
      }
    }  
    onConfirm(selectedCards.map(c => c.cardid));
    onClose();
  };

  return (
    <div className="card-picker fixed-bottom-div">
      <div className="header">
        <span className="title">
          {type === 'edit' ? 'Select Card to Edit' : `Select Cards (${limit} max.)`}
        </span>
        <button className="btn-close" onClick={onClose}></button>
      </div>
      {(type === 'add' || type === 'attach') && (
      <input
        type="text"
        className="form-control input-text"
        id="searchTokens"
        placeholder="Search by Card Name"
        value={searchQuery}
        onChange={handleSearchChange}
        style={{ margin: '5px 10px' }}
      />
      )}
      <div id="userCardsT" className="content">
        <InfiniteScroll
          dataLength={cards.length}
          next={fetchCards}
          hasMore={hasMore}
          loader={<h4>Loading...</h4>}
          scrollableTarget="userCardsT"
        >
          {cards.map((card) => (
            <img
              key={card.id}
              className={`card-selector ${
                selectedCards.some(c => c.id === card.id) && type !== 'edit' ? 'selected' : ''
              }`}
              src={`/cards/${card.cardid}.webp`}
              data-id={card.id}
              style={{ height: '250px' }}
              onClick={() => handleCardClick(card)}
              alt={`Card ${card.cardid}`}
            />
          ))}
        </InfiniteScroll>
      </div>
      {type !== 'edit' && (
        <div className="confirm-div w-100">
          <button
            id="confirm-button"
            className="btn btn-primary button-rounded"
            style={{ margin: '20px 10px' }}
            onClick={handleConfirm}
          >
            Confirm {selectedCards.length !== 0 ? `${selectedCards.length}` : ''}
          </button>
        </div>
      )}
    </div>
  );
};

export default CardPicker;